import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form';

class AddRoom extends Component {
  render() {
    const { handleSubmit, isSending } = this.props;
    return (
      <form className="edit-student-form"
        onSubmit={handleSubmit}
      >
      <div>
        <p>
            <label>Numer pokoju np. 4c</label>
            <Field
              name="roomName"
              component="input"
            />
        </p>
         <p>
            <label>Liczba miejsc</label>
            <Field
              name="size"
              component="input"
              type="number"
            />
        </p>
        <button type="submit">Dodaj Pokuj</button>
        </div>
      </form>
    )
  }
};

export default reduxForm({
    form: 'AddRoom'
  })(AddRoom);


// WEBPACK FOOTER //
// ./src/modules/Admin/components/AddRoom.js